/* tslint:disable */
import {
  WorkOrder
} from '../index';

declare var Object: any;
export interface IncomeExpenditureInterface {
  "qty"?: string;
  "description"?: string;
  "price"?: string;
  "total"?: string;
  "id"?: number;
  "work_order_id"?: number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt"?: Date;
  workOrder?: WorkOrder;
}

export class IncomeExpenditure implements IncomeExpenditureInterface {
  "qty": string;
  "description": string;
  "price": string;
  "total": string;
  "id": number;
  "work_order_id": number;
  "createdAt": Date;
  "updatedAt": Date;
  "deletedAt": Date;
  workOrder: WorkOrder;
  constructor(data?: IncomeExpenditureInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `IncomeExpenditure`.
   */
  public static getModelName() {
    return "IncomeExpenditure";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of IncomeExpenditure for dynamic purposes.
  **/
  public static factory(data: IncomeExpenditureInterface): IncomeExpenditure{
    return new IncomeExpenditure(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'IncomeExpenditure',
      plural: 'IncomeExpenditures',
      path: 'IncomeExpenditures',
      idName: 'id',
      properties: {
        "qty": {
          name: 'qty',
          type: 'string'
        },
        "description": {
          name: 'description',
          type: 'string'
        },
        "price": {
          name: 'price',
          type: 'string'
        },
        "total": {
          name: 'total',
          type: 'string'
        },
        "id": {
          name: 'id',
          type: 'number'
        },
        "work_order_id": {
          name: 'work_order_id',
          type: 'number'
        },
        "createdAt": {
          name: 'createdAt',
          type: 'Date'
        },
        "updatedAt": {
          name: 'updatedAt',
          type: 'Date'
        },
        "deletedAt": {
          name: 'deletedAt',
          type: 'Date',
          default: new Date(0)
        },
      },
      relations: {
        workOrder: {
          name: 'workOrder',
          type: 'WorkOrder',
          model: 'WorkOrder',
          relationType: 'belongsTo',
                  keyFrom: 'work_order_id',
          keyTo: 'id'
        },
      }
    }
  }
}
